function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import { getCurrentHub } from '@sentry/core';
import { addInstrumentationHandler, getEventDescription, severityLevelFromString, safeJoin, parseUrl, logger, htmlTreeAsString } from '@sentry/utils';
import { WINDOW } from '../helpers.js';
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */

var MAX_ALLOWED_STRING_LENGTH = 1024;
var BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */

var Breadcrumbs = /*#__PURE__*/function () {
  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
  function Breadcrumbs(options) {
    _classCallCheck(this, Breadcrumbs);

    Breadcrumbs.prototype.__init.call(this);

    this.options = _objectSpread({
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true
    }, options);
  }
  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */


  _createClass(Breadcrumbs, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Breadcrumbs.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      if (this.options.console) {
        addInstrumentationHandler('console', _consoleBreadcrumb);
      }

      if (this.options.dom) {
        addInstrumentationHandler('dom', _domBreadcrumb(this.options.dom));
      }

      if (this.options.xhr) {
        addInstrumentationHandler('xhr', _xhrBreadcrumb);
      }

      if (this.options.fetch) {
        addInstrumentationHandler('fetch', _fetchBreadcrumb);
      }

      if (this.options.history) {
        addInstrumentationHandler('history', _historyBreadcrumb);
      }
    }
    /**
     * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
     */

  }, {
    key: "addSentryBreadcrumb",
    value: function addSentryBreadcrumb(event) {
      if (this.options.sentry) {
        getCurrentHub().addBreadcrumb({
          category: "sentry.".concat(event.type === 'transaction' ? 'transaction' : 'event'),
          event_id: event.event_id,
          level: event.level,
          message: getEventDescription(event)
        }, {
          event: event
        });
      }
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = BREADCRUMB_INTEGRATION_ID;
    }
  }]);

  return Breadcrumbs;
}();

Breadcrumbs.__initStatic();
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */


function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    var target;
    var keyAttrs = _typeof(dom) === 'object' ? dom.serializeAttribute : undefined;
    var maxStringLength = _typeof(dom) === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;

    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn("`dom.maxStringLength` cannot exceed ".concat(MAX_ALLOWED_STRING_LENGTH, ", but a value of ").concat(maxStringLength, " was configured. Sentry will use ").concat(MAX_ALLOWED_STRING_LENGTH, " instead."));
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    } // Accessing event.target can throw (see getsentry/raven-js#838, #768)


    try {
      var event = handlerData.event;
      target = _isEvent(event) ? htmlTreeAsString(event.target, {
        keyAttrs: keyAttrs,
        maxStringLength: maxStringLength
      }) : htmlTreeAsString(event, {
        keyAttrs: keyAttrs,
        maxStringLength: maxStringLength
      });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    getCurrentHub().addBreadcrumb({
      category: "ui.".concat(handlerData.name),
      message: target
    }, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global
    });
  }

  return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */


function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (var i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }

  var breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console'
    },
    level: severityLevelFromString(handlerData.level),
    message: safeJoin(handlerData.args, ' ')
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = "Assertion failed: ".concat(safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  getCurrentHub().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level
  });
}
/**
 * Creates breadcrumbs from XHR API calls
 */


function _xhrBreadcrumb(handlerData) {
  var startTimestamp = handlerData.startTimestamp,
      endTimestamp = handlerData.endTimestamp; // We only capture complete, non-sentry requests

  if (!startTimestamp || !endTimestamp || !handlerData.xhr.__sentry_xhr__) {
    return;
  }

  var _handlerData$xhr$__se = handlerData.xhr.__sentry_xhr__,
      method = _handlerData$xhr$__se.method,
      url = _handlerData$xhr$__se.url,
      status_code = _handlerData$xhr$__se.status_code,
      body = _handlerData$xhr$__se.body;
  var data = {
    method: method,
    url: url,
    status_code: status_code
  };
  var hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp: startTimestamp,
    endTimestamp: endTimestamp
  };
  getCurrentHub().addBreadcrumb({
    category: 'xhr',
    data: data,
    type: 'http'
  }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */


function _fetchBreadcrumb(handlerData) {
  var startTimestamp = handlerData.startTimestamp,
      endTimestamp = handlerData.endTimestamp; // We only capture complete fetch requests

  if (!endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    var data = handlerData.fetchData;
    var hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp: startTimestamp,
      endTimestamp: endTimestamp
    };
    getCurrentHub().addBreadcrumb({
      category: 'fetch',
      data: data,
      level: 'error',
      type: 'http'
    }, hint);
  } else {
    var _data = _objectSpread(_objectSpread({}, handlerData.fetchData), {}, {
      status_code: handlerData.response && handlerData.response.status
    });

    var _hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp: startTimestamp,
      endTimestamp: endTimestamp
    };
    getCurrentHub().addBreadcrumb({
      category: 'fetch',
      data: _data,
      type: 'http'
    }, _hint);
  }
}
/**
 * Creates breadcrumbs from history API calls
 */


function _historyBreadcrumb(handlerData) {
  var from = handlerData.from;
  var to = handlerData.to;
  var parsedLoc = parseUrl(WINDOW.location.href);
  var parsedFrom = parseUrl(from);
  var parsedTo = parseUrl(to); // Initial pushState doesn't provide `from` information

  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  } // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)


  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }

  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  getCurrentHub().addBreadcrumb({
    category: 'navigation',
    data: {
      from: from,
      to: to
    }
  });
}

function _isEvent(event) {
  return event && !!event.target;
}

export { BREADCRUMB_INTEGRATION_ID, Breadcrumbs };